export const isAuth = bool => ({
    type: 'IS_AUTH',
    bool
})